import { IconTextSubtext, Button } from "../components";
import { FaMapLocationDot } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { IoCallSharp } from "react-icons/io5";
import { Helmet } from "react-helmet-async";

export const Contact = () => {
  const details = [
    {
      icon: <FaMapLocationDot size="35px" />,
      infoTitle: "Location:",
      infoSubtitle: "Parijsstraat 22, 3000 Leuven",
      subSubtitle: "",
    },
    {
      icon: <MdEmail size="35px" />,
      infoTitle: "Email:",
      infoSubtitle: "info@lalibela.be",
      subSubtitle: "",
    },
    {
      icon: <IoCallSharp size="35px" />,
      infoTitle: "Call:",
      infoSubtitle: <a className="hover:underline" href="tel:016 60 19 57">016 60 19 57</a>,
      subSubtitle: "",
    },
  ];

  return (
    <main>
      <Helmet>
        <title>Lalibela Leuven - Contact</title>
        <meta
          name="keywords"
          content="Ethiopian cuisine, Ethiopian restaurant, Leuven, Authentic Ethiopian food, Ethiopian dishes, Cultural dining experience, Traditional Ethiopian recipes, Vegan, Vegetarian options, Ethiopian spices, Ethiopian coffee ceremony, Parijsstraat 22, 3000 Leuve"
        />
        <meta
          name="description"
          content="Connect with Lalibela Restaurant in Leuven. Visit us at Parijsstraat 22, 3000 Leuven, or contact us at info@lalibela.be | 016 60 19 57. Leuven ethiopian restaurant."
        />
        <link rel="canonical" href="https://www.lalibela.be/contact" />
      </Helmet>

      <div className="w-full flex flex-col justify-center max-sm:flex-col-reverse">
        {
          <section>
            <div className="flex flex-row max-sm:flex-col gap-5 p-2">
              {/* Normal google location */}
              <iframe
                src={
                  "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d10068.254124857867!2d4.6807862!3d50.8855345!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c161aa065cccdd%3A0x62d5da4a37c708c2!2sLalibela%20Restaurant%20Leuven!5e0!3m2!1sen!2sbe!4v1716218209749!5m2!1sen!2sbe"
                }
                title="Google Map Location"
                width="100%"
                height="550"
                allowfullscreen=""
                loading="eager"
                referrerpolicy={"no-referrer-when-downgrade"}
              >
              </iframe>

              {/* 3D google tour */}
              <iframe src="https://www.google.com/maps/embed?pb=!4v1766168431514!6m8!1m7!1sCAoSHENJQUJJaERBR1V4aXhhaXg4Tk5jOFh2RVVWWnY.!2m2!1d50.87884956480921!2d4.699303452658629!3f241.84!4f-0.9500000000000028!5f0.4000000000000002"
                title="3d tour"
                width="100%"
                height="550"
                allowfullscreen=""
                loading="eager"
                referrerpolicy={"no-referrer-when-downgrade"}
              >
              </iframe>
            </div>
          </section>
        }

        <section>
          <div className="flex max-lg:flex-col justify-center items-center max-lg:gap-0 gap-10 px-4 max-lg:py-4">
            <Button className="hidden lg:block " text="Click for Reservation" onClick={() => { window.open("https://forms.gle/qKaXstZ7RAKXQBWG8") }}></Button>
            <span className="w-1 h-56 border-4 max-lg:hidden"></span>
            <div>
              <IconTextSubtext details={details} />
            </div>
          </div>
        </section>
      </div >
    </main >
  );
};